import React from 'react'
import styles from './EdofSection7.module.css'
function EdofSection7() {
    return (
        <div className={styles.containerBox}>
            <img className={styles.desktopImg} src='/Images/edof_secton7_new.webp' alt='edof_secton7_new' loading="lazy" decoding="async" />
            <img  className={styles.mobileImg} src='/Images/edof_secton7_newMob.webp' alt='edof_secton7_new' loading="lazy" decoding="async" />

            <div className={styles.contant}>
                <h1><span className={styles.deffrent}>"</span>This is not a multifocal.</h1>
                <p>Deseyne® EDOF lenses use a single, spherical optical zone to increase the
                    depth of field—delivering seamless, aberration-free vision at all
                    distances—without the visual distractions or cognitive
                    adaptation period typical of multifocal lenses.”</p>
                <p>- Paul Karpecki,</p>
                <p>OD, FAAO.</p>
            </div>
        </div>
    )
}

export default EdofSection7
